import { mutatorAction } from 'satcheljs';
import { getCopilotChatDrawerState } from '../store/store';

export const closeCopilotChatDrawerMutator: (targetWindow: Window) => void = mutatorAction(
    'closeCopilotChatDrawerMutator',
    (targetWindow: Window) => {
        const state = getCopilotChatDrawerState(targetWindow);
        if (!state) {
            return;
        }
        state.isShown = false;
    }
);
